import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVesselDifferentDiameters = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 97.5,
	viewBox: "0 0 50.0 97.5",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 10.0 15.0 A 10.0 10.0 0.0 1 1 40.0 15.0 L 40.0 40.0 L 50.0 50.0 L 50.0 85.0 A 20.0 10.0 0.0 0 1 0.0 85.0 L 0.0 50.25 L 10.0 40.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgVesselDifferentDiameters;
